import { render, staticRenderFns } from "./CaseStudyTableInactive.vue?vue&type=template&id=268a0726"
import script from "./CaseStudyTableInactive.vue?vue&type=script&lang=js"
export * from "./CaseStudyTableInactive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports